import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const getPages = (current, totalPages) => {
  const pages = [];
  const add = (p) => { if (!pages.includes(p)) pages.push(p); };
  add(1);
  for (let p = current - 1; p <= current + 1; p++) {
    if (p > 1 && p < totalPages) add(p);
  }
  if (totalPages > 1) add(totalPages);
  // insert ellipsis markers
  const result = [];
  let prev = 0;
  for (const p of pages.sort((a, b) => a - b)) {
    if (prev && p - prev > 1) result.push('...');
    result.push(p);
    prev = p;
  }
  return result;
};

const Pagination = ({ page, pageSize, total, onChange }) => {
  const totalPages = Math.ceil((total || 0) / pageSize);
  if (totalPages <= 1) return null;

  const go = (p) => {
    if (p < 1 || p > totalPages || p === page) return;
    onChange(p);
  };

  const pages = getPages(page, totalPages);
  const btn = "min-w-[40px] h-10 px-3 rounded-lg font-semibold text-sm transition-colors flex items-center justify-center";

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 mt-8" data-testid="catalog-pagination">
      <button
        onClick={() => go(page - 1)}
        disabled={page === 1}
        className={`${btn} border-2 border-gray-200 text-gray-700 hover:border-green-500 disabled:opacity-40 disabled:cursor-not-allowed`}
        data-testid="pagination-prev"
      >
        <ChevronLeft className="h-4 w-4" />
      </button>

      {pages.map((p, i) =>
        p === '...' ? (
          <span key={`e${i}`} className="px-2 text-gray-400">…</span>
        ) : (
          <button
            key={p}
            onClick={() => go(p)}
            className={`${btn} border-2 ${
              p === page
                ? 'bg-green-600 border-green-600 text-white'
                : 'border-gray-200 text-gray-700 hover:border-green-500'
            }`}
            data-testid={`pagination-page-${p}`}
          >
            {p}
          </button>
        )
      )}

      <button
        onClick={() => go(page + 1)}
        disabled={page === totalPages}
        className={`${btn} border-2 border-gray-200 text-gray-700 hover:border-green-500 disabled:opacity-40 disabled:cursor-not-allowed`}
        data-testid="pagination-next"
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
};

export default Pagination;
